import React from 'react';
import classNames from 'classnames';

type AssistantContentProps = {
  children: any;
} & React.HTMLAttributes<HTMLDivElement>;

export const AssistantContent = ({children, ...props}: AssistantContentProps) => {
  const containerClasses = classNames(
    'overflow-auto',
    'flex',
    'flex-col',
    'flex-1',
    props.className
  );

  return (
    <div id="assistant-content" className={containerClasses}>
      {children}
    </div>
  );
};
